/** Payments */
export const FETCH_PAYMENTS_CREDITS_REQUEST = 'FETCH_PAYMENTS_CREDITS_REQUEST';
export const FETCH_PAYMENTS_CREDITS_SUCCESS = 'FETCH_PAYMENTS_CREDITS_SUCCESS';
export const FETCH_PAYMENTS_CREDITS_FAILURE = 'FETCH_PAYMENTS_CREDITS_FAILURE';
export const UPDATE_PAYMENTS_EMAILS_REQUEST = 'UPDATE_PAYMENTS_EMAILS_REQUEST';
export const UPDATE_PAYMENTS_EMAILS_SUCCESS = 'UPDATE_PAYMENTS_EMAILS_SUCCESS';
export const UPDATE_PAYMENTS_EMAILS_FAILURE = 'UPDATE_PAYMENTS_EMAILS_FAILURE';
/** Transactions */
export const FETCH_PURCHASES_REQUEST = 'FETCH_PURCHASES_REQUEST';
export const FETCH_PURCHASES_SUCCESS = 'FETCH_PURCHASES_SUCCESS';
export const FETCH_PURCHASES_FAILURE = 'FETCH_PURCHASES_FAILURE';
export const FETCH_ALL_PURCHASES_REQUEST = 'FETCH_ALL_PURCHASES_REQUEST';
export const FETCH_ALL_PURCHASES_SUCCESS = 'FETCH_ALL_PURCHASES_SUCCESS';
export const FETCH_ALL_PURCHASES_FAILURE = 'FETCH_ALL_PURCHASES_FAILURE';
/** PayPal */
export const PAYPAL_PAY_REQUEST = 'PAYPAL_PAY_REQUEST';
export const PAYPAL_PAY_SUCCESS = 'PAYPAL_PAY_SUCCESS';
export const PAYPAL_PAY_FAILURE = 'PAYPAL_PAY_FAILURE';
/** Denominations */
export const FETCH_DENOMINATIONS_REQUEST = 'FETCH_DENOMINATIONS_REQUEST';
export const FETCH_DENOMINATIONS_SUCCESS = 'FETCH_DENOMINATIONS_SUCCESS';
export const FETCH_DENOMINATIONS_FAILURE = 'FETCH_DENOMINATIONS_FAILURE';

export const SAVE_AUTOMATIC_RECHARGE_REQUEST = 'SAVE_AUTOMATIC_RECHARGE_REQUEST';
export const SAVE_AUTOMATIC_RECHARGE_SUCCESS = 'SAVE_AUTOMATIC_RECHARGE_SUCCESS';
export const SAVE_AUTOMATIC_RECHARGE_FAILURE = 'SAVE_AUTOMATIC_RECHARGE_FAILURE';
export const FETCH_AUTOMATIC_PAYMENT_REQUEST = 'FETCH_AUTOMATIC_PAYMENT_REQUEST';
export const FETCH_AUTOMATIC_PAYMENT_SUCCESS = 'FETCH_AUTOMATIC_PAYMENT_SUCCESS';
export const FETCH_AUTOMATIC_PAYMENT_FAILURE = 'FETCH_AUTOMATIC_PAYMENT_FAILURE';
export const EDIT_AUTOMATIC_RECHARGE_REQUEST = 'EDIT_AUTOMATIC_RECHARGE_REQUEST';
export const EDIT_AUTOMATIC_RECHARGE_SUCCESS = 'EDIT_AUTOMATIC_RECHARGE_SUCCESS';
export const EDIT_AUTOMATIC_RECHARGE_FAILURE = 'EDIT_AUTOMATIC_RECHARGE_FAILURE';
export const REMOVE_AUTOMATIC_RECHARGE_REQUEST = 'REMOVE_AUTOMATIC_RECHARGE_REQUEST';
export const REMOVE_AUTOMATIC_RECHARGE_SUCCESS = 'REMOVE_AUTOMATIC_RECHARGE_SUCCESS';
export const REMOVE_AUTOMATIC_RECHARGE_FAILURE = 'REMOVE_AUTOMATIC_RECHARGE_FAILURE';
export const CREDIT_RECHARGE_REQUEST = 'CREDIT_RECHARGE_REQUEST';
export const CREDIT_RECHARGE_SUCCESS = 'CREDIT_RECHARGE_SUCCESS';
export const CREDIT_RECHARGE_FAILURE = 'CREDIT_RECHARGE_FAILURE';
